import Form     from './form'
import Input    from './input'
import View     from './view'
import inputify from './inputify'

export default Views =
  Form:     Form
  Input:    Input
  View:     View
  inputify: inputify
